import { PrintModel } from "./print.model";

export var mock_print: PrintModel[] = [
  {
    id: 1,
    type: "CHI TIẾT HÀNG ĐI TUYẾN",
    fromAirport: "",
    createdBy: "Nguyễn Hoàng Thông",
    createdPhone: "01652784460",
    receiverBy: "PHạm Văn B",
    receiverPhone: "0998",
    listShipment: {
      shipmentNumber: "1KHDSHFS11111",
      senderName: "abc",
      receiverName: "xyz",
      fromHub: "HCM",
      toHub: "HN",
      fromWard: "KKB",
      toWard: "DDT",
      service: "DSC",
      shippingAddress: "Bàu Cát, Tân Bình",
      weight: 300,
      deliverUserId: 1845,
    }
  },
  {
    id: 2,
    type: "CHI TIẾT HÀNG ĐI TUYẾN",
    fromAirport: "",
    createdBy: "Nguyễn Hoàng Thông",
    createdPhone: "01652784460",
    receiverBy: "PHạm Văn B",
    receiverPhone: "0998",
    listShipment: {
      shipmentNumber: "1KHDdedeFS111112",
      senderName: "abc",
      receiverName: "xyz",
      fromHub: "HCM",
      toHub: "HN",
      fromWard: "KKB",
      toWard: "DDT",
      service: "DSC",
      shippingAddress: "Bàu Cát, Tân Bình",
      weight: 200,
      deliverUserId: 1845,
    }
  },
  {
    id: 3,
    type: "CHI TIẾT HÀNG ĐI TUYẾN",
    fromAirport: "",
    createdBy: "Nguyễn Hoàng Thông",
    createdPhone: "01652784460",
    receiverBy: "PHạm Văn B",
    receiverPhone: "0998",
    listShipment: {
      shipmentNumber: "1KHD47FS111113",
      senderName: "abc",
      receiverName: "xyz",
      fromHub: "HCM",
      toHub: "HN",
      fromWard: "KKB",
      toWard: "DDT",
      service: "DSC",
      shippingAddress: "Bàu Cát, Tân Bình",
      weight: 300,
      deliverUserId: 1845,
    }
  },
  {
    id: 4,
    type: "CHI TIẾT HÀNG ĐI TUYẾN",
    fromAirport: "",
    createdBy: "Nguyễn Hoàng Thông",
    createdPhone: "01652784460",
    receiverBy: "PHạm Văn B",
    receiverPhone: "0998",
    listShipment: {
      shipmentNumber: "1KHddHFS111114",
      senderName: "abc",
      receiverName: "xyz",
      fromHub: "HCM",
      toHub: "HN",
      fromWard: "KKB",
      toWard: "DDT",
      service: "DSC",
      shippingAddress: "Bàu Cát, Tân Bình",
      weight: 400,
      deliverUserId: 1845,
    }
  },
  {
    id: 5,
    type: "CHI TIẾT HÀNG ĐI TUYẾN",
    fromAirport: "",
    createdBy: "Nguyễn Hoàng Thông",
    createdPhone: "01652784460",
    receiverBy: "PHạm Văn B",
    receiverPhone: "0998",
    listShipment: {
      shipmentNumber: "1KHD78ascFS111115",
      senderName: "abc",
      receiverName: "xyz",
      fromHub: "HCM",
      toHub: "HN",
      fromWard: "KKB",
      toWard: "DDT",
      service: "DSC",
      shippingAddress: "Bàu Cát, Tân Bình",
      weight: 500,
      deliverUserId: 1845,
    }
  },
  {
    id: 6,
    type: "NHẬN TRUNG TÂM",
    fromAirport: "",
    createdBy: "Nguyễn Hoàng Thông",
    createdPhone: "01652784460",
    receiverBy: "PHạm Văn B",
    receiverPhone: "0998",
    listShipment: {
      shipmentNumber: "1KHDSHS14561115",
      senderName: "abc",
      receiverName: "xyz",
      fromHub: "HCM",
      toHub: "HN",
      fromWard: "KKB",
      toWard: "DDT",
      service: "DSC",
      shippingAddress: "Bàu Cát, Tân Bình",
      weight: 600,
      deliverUserId: 1845,
    }
  },
  {
    id: 7,
    type: "NHẬN TRUNG TÂM",
    fromAirport: "",
    createdBy: "Nguyễn Hoàng Thông",
    createdPhone: "01652784460",
    receiverBy: "PHạm Văn B",
    receiverPhone: "0998",
    listShipment: {
      shipmentNumber: "1KdfdfHS14561115",
      senderName: "abc",
      receiverName: "xyz",
      fromHub: "HCM",
      toHub: "HN",
      fromWard: "KKB",
      toWard: "DDT",
      service: "DSC",
      shippingAddress: "Bàu Cát, Tân Bình",
      weight: 700,
      deliverUserId: 1845,
    }
  },
  {
    id: 8,
    type: "NHẬN TRUNG TÂM",
    fromAirport: "",
    createdBy: "Nguyễn Hoàng Thông",
    createdPhone: "01652784460",
    receiverBy: "PHạm Văn B",
    receiverPhone: "0998",
    listShipment: {
      shipmentNumber: "wdcfdfHS145611",
      senderName: "abc",
      receiverName: "xyz",
      fromHub: "HCM",
      toHub: "HN",
      fromWard: "KKB",
      toWard: "DDT",
      service: "DSC",
      shippingAddress: "Bàu Cát, Tân Bình",
      weight: 800,
      deliverUserId: 1845,
    }
  },
  {
    id: 9,
    type: "NHẬN TRUNG TÂM",
    fromAirport: "",
    createdBy: "Nguyễn Hoàng Thông",
    createdPhone: "01652784460",
    receiverBy: "PHạm Văn B",
    receiverPhone: "0998",
    listShipment: {
      shipmentNumber: "hjydfdfHS145611",
      senderName: "abc",
      receiverName: "xyz",
      fromHub: "HCM",
      toHub: "HN",
      fromWard: "KKB",
      toWard: "DDT",
      service: "DSC",
      shippingAddress: "Bàu Cát, Tân Bình",
      weight: 900,
      deliverUserId: 1845,
    }
  },
  {
    id: 10,
    type: "HÀNG ĐI TUYẾN",
    fromAirport: "",
    createdBy: "Nguyễn Hoàng Thông",
    createdPhone: "01652784460",
    receiverBy: "PHạm Văn B",
    receiverPhone: "0998",
    listShipment: {
      shipmentNumber: "1Kdf9jyeS145611",
      senderName: "abc",
      receiverName: "xyz",
      fromHub: "HCM",
      toHub: "HN",
      fromWard: "KKB",
      toWard: "DDT",
      service: "DSC",
      shippingAddress: "Bàu Cát, Tân Bình",
      weight: 1000,
      deliverUserId: 1845,
    }
  },
  {
    id: 11,
    type: "HÀNG ĐI TUYẾN",
    fromAirport: "",
    createdBy: "Nguyễn Hoàng Thông",
    createdPhone: "01652784460",
    receiverBy: "PHạm Văn B",
    receiverPhone: "0998",
    listShipment: {
      shipmentNumber: "1Kdf978rS145611",
      senderName: "abc",
      receiverName: "xyz",
      fromHub: "HCM",
      toHub: "HN",
      fromWard: "KKB",
      toWard: "DDT",
      service: "DSC",
      shippingAddress: "Bàu Cát, Tân Bình",
      weight: 1100,
      deliverUserId: 1845,
    }
  },
  {
    id: 12,
    type: "HÀNG ĐI TUYẾN",
    fromAirport: "",
    createdBy: "Nguyễn Hoàng Thông",
    createdPhone: "01652784460",
    receiverBy: "PHạm Văn B",
    receiverPhone: "0998",
    listShipment: {
      shipmentNumber: "1Kwq9jyeS14435",
      senderName: "abc",
      receiverName: "xyz",
      fromHub: "HCM",
      toHub: "HN",
      fromWard: "KKB",
      toWard: "DDT",
      service: "DSC",
      shippingAddress: "Bàu Cát, Tân Bình",
      weight: 1200,
      deliverUserId: 1845,
    }
  },
  {
    id: 13,
    type: "HÀNG ĐI TUYẾN",
    fromAirport: "",
    createdBy: "Nguyễn Hoàng Thông",
    createdPhone: "01652784460",
    receiverBy: "PHạm Văn B",
    receiverPhone: "0998",
    listShipment: {
      shipmentNumber: "1Kdf9gteS145",
      senderName: "abc",
      receiverName: "xyz",
      fromHub: "HCM",
      toHub: "HN",
      fromWard: "KKB",
      toWard: "DDT",
      service: "DSC",
      shippingAddress: "Bàu Cát, Tân Bình",
      weight: 1300,
      deliverUserId: 1845,
    }
  },
];



// WEBPACK FOOTER //
// C:/Users/LIVE02/Documents/SSW/ThanhBuoi/TBE_CRM/src/app/models/mock_print.ts